import { z } from 'zod';
import { ZodArrayToEnum } from '@axiom/types';
import {
  CountryCodeAddressCountryValues,
  CountryCodeValues,
} from '@axiom/const';

export const PreferencesMfaPhoneAddModalFormSchema = z.object({
  country: z.enum(ZodArrayToEnum(CountryCodeAddressCountryValues)),
  countryCode: z.enum(ZodArrayToEnum(CountryCodeValues)),
  phoneNumber: z
    .string()
    .regex(/^\d+$/, { message: 'Please add a valid phone number' }),
});
